import { getApiErrorMessage } from "./apiErrors";

// French text for a failed POST /api/media_objects. The
// `validation.media_object.error.file.*` keys (scanifood_api MediaObject::$file
// constraints) are in the shared map (`src/lib/apiErrorMessages.ts`).
const DEFAULT_MEDIA_UPLOAD_ERROR =
  "Échec de l'envoi de l'image. Veuillez réessayer.";

export const getMediaUploadErrorMessage = (error: unknown): string =>
  getApiErrorMessage(error, DEFAULT_MEDIA_UPLOAD_ERROR);
